import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
   getMyMfaDetailsRequest: ['token'],
   getMyMfaDetailsSuccess: ['myMfaDetails'],
   getMyMfaDetailsFailure: ['error'],

   removeSmsEnrollmentRequest: ['token'],
   removeSmsEnrollmentSuccess: ['response'],
   removeSmsEnrollmentFailure: ['response'],

   removeAuthenticatorEnrollmentRequest: ['token'],
   removeAuthenticatorEnrollmentSuccess: ['response'],
   removeAuthenticatorEnrollmentFailure: ['response'],

   changeDefaultMfaMethodRequest: ['token', 'newMethod'],
   changeDefaultMfaMethodSuccess: ['response'],
   changeDefaultMfaMethodFailure: ['response'],
});

export const IdentityTypes = Types;
export default Creators;

export const INITIAL_STATE = {
   myMfaDetails: null,
   myMfaDetailsLoading: false,
   removeSmsEnrollmentResponse: null,
   removeSmsEnrollmentLoading: false,
   removeAuthenticatorEnrollmentResponse: null,
   removeAuthenticatorEnrollmentLoading: false,
   changeDefaultMfaMethodResponse: null,
   changeDefaultMfaMethodLoading: false,
};

const getMyMfaDetailsRequest = state => ({
   ...state,
   myMfaDetailsLoading: true,
});

const getMyMfaDetailsSuccess = (state, action) => ({
   ...state,
   myMfaDetails: action.myMfaDetails,
   myMfaDetailsLoading: false,
});

const getMyMfaDetailsFailure = state => ({
   ...state,
   myMfaDetails: null,
   myMfaDetailsLoading: false,
});

const removeSmsEnrollmentRequest = state => ({
   ...state,
   removeSmsEnrollmentLoading: true,
});

const removeSmsEnrollmentSuccess = (state, action) => ({
   ...state,
   removeSmsEnrollmentResponse: action.response,
   removeSmsEnrollmentLoading: false,
});

const removeSmsEnrollmentFailure = (state, action) => ({
   ...state,
   removeSmsEnrollmentResponse: action.response,
   removeSmsEnrollmentLoading: false,
});

const removeAuthenticatorEnrollmentRequest = state => ({
   ...state,
   removeAuthenticatorEnrollmentLoading: true,
});

const removeAuthenticatorEnrollmentSuccess = (state, action) => ({
   ...state,
   removeAuthenticatorEnrollmentResponse: action.response,
   removeAuthenticatorEnrollmentLoading: false,
});

const removeAuthenticatorEnrollmentFailure = (state, action) => ({
   ...state,
   removeAuthenticatorEnrollmentResponse: action.response,
   removeAuthenticatorEnrollmentLoading: false,
});

const changeDefaultMfaMethodRequest = state => ({
   ...state,
   changeDefaultMfaMethodLoading: true,
});

const changeDefaultMfaMethodSuccess = (state, action) => ({
   ...state,
   changeDefaultMfaMethodResponse: action.response,
   changeDefaultMfaMethodLoading: false,
});

const changeDefaultMfaMethodFailure = (state, action) => ({
   ...state,
   changeDefaultMfaMethodResponse: action.response,
   changeDefaultMfaMethodLoading: false,
});

export const reducer = createReducer(INITIAL_STATE, {
   [Types.GET_MY_MFA_DETAILS_REQUEST]: getMyMfaDetailsRequest,
   [Types.GET_MY_MFA_DETAILS_SUCCESS]: getMyMfaDetailsSuccess,
   [Types.GET_MY_MFA_DETAILS_FAILURE]: getMyMfaDetailsFailure,

   [Types.REMOVE_SMS_ENROLLMENT_REQUEST]: removeSmsEnrollmentRequest,
   [Types.REMOVE_SMS_ENROLLMENT_SUCCESS]: removeSmsEnrollmentSuccess,
   [Types.REMOVE_SMS_ENROLLMENT_FAILURE]: removeSmsEnrollmentFailure,

   [Types.REMOVE_AUTHENTICATOR_ENROLLMENT_REQUEST]: removeAuthenticatorEnrollmentRequest,
   [Types.REMOVE_AUTHENTICATOR_ENROLLMENT_SUCCESS]: removeAuthenticatorEnrollmentSuccess,
   [Types.REMOVE_AUTHENTICATOR_ENROLLMENT_FAILURE]: removeAuthenticatorEnrollmentFailure,

   [Types.CHANGE_DEFAULT_MFA_METHOD_REQUEST]: changeDefaultMfaMethodRequest,
   [Types.CHANGE_DEFAULT_MFA_METHOD_SUCCESS]: changeDefaultMfaMethodSuccess,
   [Types.CHANGE_DEFAULT_MFA_METHOD_FAILURE]: changeDefaultMfaMethodFailure,
});

export const selectMyMfaDetails = state => state.identity.myMfaDetails;

export const selectMyMfaDetailsLoading = state =>
   state.identity.myMfaDetailsLoading;

export const selectRemoveSmsEnrollmentResponse = state =>
   state.identity.removeSmsEnrollmentResponse;

export const selectRemoveSmsEnrollmentLoading = state =>
   state.identity.removeSmsEnrollmentLoading;

export const selectRemoveAuthenticatorEnrollmentResponse = state =>
   state.identity.removeAuthenticatorEnrollmentResponse;

export const selectRemoveAuthenticatorEnrollmentLoading = state =>
   state.identity.removeAuthenticatorEnrollmentLoading;

export const selectChangeDefaultMfaMethodResponse = state =>
   state.identity.changeDefaultMfaMethodResponse;

export const selectChangeDefaultMfaMethodLoading = state =>
   state.identity.changeDefaultMfaMethodLoading;
